<template>
  <div class="m-common__review__menu">
    <ul>
      <li class="review__menu__count">レビュー<span class="num">{{ count }}</span></li>
      <li class="review__menu__sort">
        <label>
        <select id="reviewHistorySort" dir="rtl" v-model="selectedSortValue" @change="onChangeSort">
          <option value="review_date_desc" selected="selected">投稿日の新しい順</option>
          <option value="review_helpful_desc">役に立った数が多い順</option>
          <option value="review_star_desc">星の数が多い順</option>
          <option value="review_star_asc">星の数が少ない順</option>
        </select>
        </label>
      </li>
      <li class="review__menu__narrow" v-if="isRenderRefiner" >
        <label>絞り込み</label>
        <div class="review__menu__narrow-inner">
        <select id="reviewStarSort"  dir="rtl" v-model="selectedRefineValue" @change="onChangeRefine">
          <option value="review_star_all" selected="selected">すべてのレビュー</option>
          <option value="review_star_5">星5つのレビュー</option>
          <option value="review_star_4">星4つのレビュー</option>
          <option value="review_star_3">星3つのレビュー</option>
          <option value="review_star_2">星2つのレビュー</option>
          <option value="review_star_1">星1つのレビュー</option>
        </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import sorts from '@/mixins/sorts'
import errors from '@/mixins/errors'
import { mapActions } from 'vuex'
export default {
  name: 'CommonReviewsMenu',
  mixins: [ sorts, errors ],
  props: {
    count: {
      type: Number,
      default: 0
    },
    defaultSortValue: {
      type: String,
      default: 'review_date_desc'
    },
    defaultRefineValue: {
      type: String,
      default: 'review_star_all'
    },
    isRenderRefiner: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedSortValue: this.defaultSortValue,
      selectedRefineValue: this.defaultRefineValue
    }
  },
  methods: {
    ...mapActions({
      sortReviews: 'storeReviews/sortReviews',
      refineReviews: 'storeReviews/refineReviews'
    }),
    onChangeSort () {
      // ソート
      this.sortReviews({
        orderValue: this.getOrderValue(this.selectedSortValue),
        sortValue: this.getSortValue(this.selectedSortValue),
        start: 0
      }).then(() => {
        if (this.isAuthenticationError) {
          this.onAuthenticationError()
        }
      })
    },
    onChangeRefine () {
      // 絞り込み
      this.refineReviews({
        refineValue: this.getRefineValue(this.selectedRefineValue),
        start: 0
      }).then(() => {
        if (this.isAuthenticationError) {
          this.onAuthenticationError()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewsMenu.vue